import Vue from 'vue';
import { pushEvent } from "./analytics.mjs";

const faqDefinition = {
    data : {
        booted   : true,
        expanded : {}
    },
    methods : {
        onTopicClick : function( event, topicId ) {

        },
        onToggleClick : function( event, itemRef, question ) { console.log('hello?');
            if( this.$refs.hasOwnProperty(itemRef) ) {
                this.expanded[ itemRef ] = ! this.getVisibleForIdentifier(itemRef);

                if( this.expanded[ itemRef ] ) {
                    pushEvent( this.$el.id, 'topic open', question );
                }

                this.$forceUpdate();
            }
        },
        getVisibleForIdentifier : function( ident ) {
            return this.expanded.hasOwnProperty( ident )
                && this.expanded[ident] === true
            ;
        }
    }
};

let faqElements = document.getElementsByClassName('faq-section');

for( let element of faqElements ) {
    new Vue({
        ...faqDefinition,
        el : element
    });
}




